import type { ApprovalChain } from '../approval-chain.model';

export const CAVEAT_UPLIFT_CHAIN: ApprovalChain = {
  id: 'caveat-uplift',
  label: 'Caveat Upliftment',
  applicationTypes: ['CAVEAT_UPLIFT'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED', 'SUBMITTED', 'RESUBMITTED', 'PENDING_REVIEW'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Approve', from: ['EXAMINER_RECOMMENDED'], to: 'APPROVED' },
  ],
};
